{
  "loading": "Cargando…",
  "placeholder": "Seleccione…"
}
